import propTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import Iconify from '../Iconify'

Checkbox.propTypes = {
  label: propTypes.string.isRequired,
  size: propTypes.oneOf(['small', 'medium', 'large', 'extraLarge'])
}

Checkbox.defaultProps = {
  size: 'medium'
}

export default function Checkbox ({ label, value, size, ...props }) {
  const id = typeof label === 'string'
    ? label.toLowerCase().replace(/\s/g, '-')
    : ''

  const handleChange = (event) => {
    event.stopPropagation()
    if (event.target && typeof props.onChange === 'function') {
      props.onChange(props.name, event.target.checked)
    }
  }

  return (
    <Field {...props}>
      <Input
        id={id}
        checked={value}
        type='checkbox'
        onChange={handleChange}
        disabled={props.disabled}
        size={size}
      />
      <Label htmlFor={id}>
        <Box size={size} checked={value} disabled={props.disabled}>
          <CheckIcon size={size} visible={value}>
            <Iconify
              icon='mdi:check-bold'
              color='#fff'
              style={{ fontSize: getCheckSize(size) }}
            />
          </CheckIcon>
        </Box>
        {label}
      </Label>
    </Field>
  )
}

const getSize = (size) => {
  const sizes = {
    small: 14,
    medium: 17,
    large: 24,
    extraLarge: 32
  }
  return sizes[size] || sizes.medium
}

const getCheckSize = (size) => {
  const sizes = {
    small: 10,
    medium: 12,
    large: 16,
    extraLarge: 22
  }
  return sizes[size] || sizes.medium
}

const Input = styled.input`
  position: absolute;
  opacity: 0;
`

const Label = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 0;
  margin: 0;
  font-weight: normal;
  line-height: 1;
`

const CheckIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${props => getCheckSize(props.size)}px;
  height: ${props => getCheckSize(props.size)}px;
  opacity: ${props => props.visible ? 1 : 0};
  transition: opacity 100ms;
  line-height: 0;
`

const Box = styled.div`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${props => getSize(props.size)}px;
  height: ${props => getSize(props.size)}px;
  line-height: 0;
  background: ${props => {
    if (props.disabled) return '#ddd'
    if (props.checked) return '#78bc28'
    return 'transparent'
  }};
  border: 2px solid #78bc28;
  border-radius: 0.3em;
  transition: background-color 100ms;

  ${Input}:focus + ${Label} & {
    box-shadow: 0 0 0 3px #88ba4429;
  }

  ${Input}:hover:not(:checked):not(:disabled) + ${Label} & {
    background-color: #3a3a3a;
  }
`

const Field = styled.div`
  position: relative;
  user-select: none;
  margin-bottom: 0;

  ${Input}:disabled + ${Label} {
    color: #78bc28;
    cursor: auto;
  }
`
